import {Box, Card, Tooltip} from "@mui/material";
import {styled} from "@mui/material/styles";
import {List} from "@mui/icons-material";
import {COLORS} from "../../../ui/Theme";
import {useRoiIndustryContext} from "../../../context/roi/industry/RoiIndustryContext";
import {ListDivider} from "../../../ui/ListStyles";

const roiPeriodData = [
    {label: "هفتگی", value: "weekly_roi"},
    {label: "ماهانه", value: "monthly_roi"},
    {label: "سه ماهه", value: "quarterly_roi"},
    {label: "شش ماهه", value: "half_yearly_roi"},
    {label: "سالانه", value: "yearly_roi"},
    {label: "سه ساله", value: "three_years_roi"},
];

const Typography = styled("p")({
    fontSize: "12px",
    direction: "rtl",
});

const Row = styled("div")({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
});

const RoiIndustry = ({data}) => {
    const {setShowStocks, setSelectedIndustry} = useRoiIndustryContext();

    const handleShowStocks = () => {
        setSelectedIndustry({
            id: data.industrial_group_id,
            name: data.industrial_group_name,
        });

        setShowStocks(true);
    };

    return (
        <Card sx={{display: "flex", flexDirection: "column", gap: "8px"}}>
            <Tooltip title={data.industrial_group_name}>
                <Typography
                    sx={{
                        fontWeight: 700,
                        textAlign: "center",
                        whiteSpace: "nowrap",
                        textOverflow: "ellipsis",
                        overflow: "hidden",
                        direction: "ltr",
                    }}
                >
                    {data.industrial_group_name}
                </Typography>
            </Tooltip>

            <ListDivider flexItem/>

            <Box sx={{display: "flex", flexDirection: "column", gap: "8px"}}>
                {roiPeriodData.map((item) => (
                    <Row key={item.value}>
                        <Typography>{item.label}</Typography>
                        <Typography
                            sx={{
                                color: data[item.value] >= 0 ? COLORS.GREEN : COLORS.RED,
                                fontWeight: "700",
                            }}
                        >
                            {data[item.value]}%
                        </Typography>
                    </Row>
                ))}
            </Box>
            <button
                onClick={handleShowStocks}
                className="btn"
                style={{fontWeight: 400}}
            >
                سهم‌ها
                <List/>
            </button>
        </Card>
    );
};

export default RoiIndustry;
